import { Col, Input } from "antd";

import { ITextField } from "./ITextField";

import { sizes } from "../../../Assets/Enums";

const DateField = ({
	size,
	label,
	placeholder,
	value,
	fieldName,
	errorWhenEmpty = false,
	translations,
	required,
	errors,
	index = 0,
	disabled = false,
	handleChange
}: ITextField) => (
	<Col xs={24} md={sizes[size]} lg={sizes[size]} className="titles">
		{(() => {
			const hasError = Array.isArray(errors)
				? Boolean(errors[index]?.[fieldName])
				: Boolean(errors[fieldName]);
			const shouldShowError = hasError && (!errorWhenEmpty || !value);

			return (
				<>
		<p>
			<label className={required ? "required" : ""}> {label || translations[fieldName]} </label>
		</p>
		<Input
			placeholder={placeholder}
			type="text"
			name={fieldName}
			value={value}
			onChange={handleChange(index)}
			disabled={disabled}
			status={shouldShowError ? "error" : ""}
		/>
		{
			required && errors ?
				<span className={`error ${shouldShowError ? 'show' : null}`}>{translations.completeCampo}</span>
			: null
		}
				</>
			);
		})()}
	</Col>
);

export default DateField;
